module.exports = __webpack_public_path__ + "img/05.02a5a7f8.jpg";